//=require jquery-validation/jquery.validate.js
//=require jquery-validation/localization/messages_de.js




$(document).ready(function () {
  var options = {};
  $('form').each(function () {
    if (!$(this).hasClass('novalidate')) {
      $(this).validate(options);
    }
  });
});